import { render, staticRenderFns } from "./upload_msg.vue?vue&type=template&id=6a13bbfa&scoped=true&"
import script from "./upload_msg.vue?vue&type=script&lang=js&"
export * from "./upload_msg.vue?vue&type=script&lang=js&"
import style0 from "./upload_msg.vue?vue&type=style&index=0&id=6a13bbfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a13bbfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a13bbfa')) {
      api.createRecord('6a13bbfa', component.options)
    } else {
      api.reload('6a13bbfa', component.options)
    }
    module.hot.accept("./upload_msg.vue?vue&type=template&id=6a13bbfa&scoped=true&", function () {
      api.rerender('6a13bbfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/ads_manage/form/components/upload_msg.vue"
export default component.exports